"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetHierarchyImpl = void 0;
var HttpError_1 = require("../../model/HttpError");
var UrlBuilder_1 = require("./UrlBuilder");
var GetHierarchyImpl = /** @class */ (function () {
    function GetHierarchyImpl(contentClient, assembler) {
        this.contentClient = contentClient;
        this.assembler = assembler;
        this.hierarchyUrlBuilder = new UrlBuilder_1.HierarchyURLBuilder();
    }
    GetHierarchyImpl.prototype.getByHierarchy = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var content, data, _a, _b, _c, err_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        content = [];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this.contentClient.get(this.hierarchyUrlBuilder.buildUrl(request))];
                    case 2:
                        data = (_d.sent()).data;
                        content.push.apply(content, data.responses);
                        if (!(data.page.cursor != undefined)) return [3 /*break*/, 4];
                        request.pageCursor = data.page.cursor;
                        _b = (_a = content.push).apply;
                        _c = [content];
                        return [4 /*yield*/, this.getByHierarchy(request)];
                    case 3:
                        _b.apply(_a, _c.concat([(_d.sent())]));
                        _d.label = 4;
                    case 4: return [2 /*return*/, content];
                    case 5:
                        err_1 = _d.sent();
                        if (err_1.response) {
                            throw new HttpError_1.HttpError(err_1.response.status, err_1.response.data);
                        }
                        throw err_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    GetHierarchyImpl.prototype.getHierarchyByRoot = function (request, rootItem) {
        return __awaiter(this, void 0, void 0, function () {
            var hierarchyData, rootHierarchyItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getByHierarchy(request)];
                    case 1:
                        hierarchyData = _a.sent();
                        rootHierarchyItem = this.assembler.assembleRoot(rootItem, hierarchyData);
                        return [2 /*return*/, rootHierarchyItem];
                }
            });
        });
    };
    return GetHierarchyImpl;
}());
exports.GetHierarchyImpl = GetHierarchyImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2V0SGllcmFyY2h5SW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9jb29yZGluYXRvcnMvR2V0QnlIaWVyYXJjaHkvR2V0SGllcmFyY2h5SW1wbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFRQSxtREFBa0Q7QUFJbEQsMkNBQW1EO0FBRW5EO0lBSUUsMEJBQ21CLGFBQTRCLEVBQzVCLFNBQW1DO1FBRG5DLGtCQUFhLEdBQWIsYUFBYSxDQUFlO1FBQzVCLGNBQVMsR0FBVCxTQUFTLENBQTBCO1FBRXBELElBQUksQ0FBQyxtQkFBbUIsR0FBRyxJQUFJLGdDQUFtQixFQUFFLENBQUM7SUFDdkQsQ0FBQztJQUVhLHlDQUFjLEdBQTVCLFVBQ0UsT0FBeUI7Ozs7Ozt3QkFFbkIsT0FBTyxHQUFxQyxFQUFFLENBQUM7Ozs7d0JBRWxDLHFCQUFNLElBQUksQ0FBQyxhQUFhLENBQUMsR0FBRyxDQUMzQyxJQUFJLENBQUMsbUJBQW1CLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxDQUMzQyxFQUFBOzt3QkFGTyxJQUFJLEdBQUssQ0FBQSxTQUVoQixDQUFBLEtBRlc7d0JBSVosT0FBTyxDQUFDLElBQUksT0FBWixPQUFPLEVBQVMsSUFBSSxDQUFDLFNBQVMsRUFBRTs2QkFDNUIsQ0FBQSxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sSUFBSSxTQUFTLENBQUEsRUFBN0Isd0JBQTZCO3dCQUMvQixPQUFPLENBQUMsVUFBVSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDOzZCQUN0QyxDQUFBLEtBQUEsT0FBTyxDQUFDLElBQUksQ0FBQTs4QkFBWixPQUFPO3dCQUFVLHFCQUFNLElBQUksQ0FBQyxjQUFjLENBQUMsT0FBTyxDQUFDLEVBQUE7O3dCQUFuRCx3QkFBZ0IsQ0FBQyxTQUFrQyxDQUFDLElBQUU7OzRCQUV4RCxzQkFBTyxPQUFPLEVBQUM7Ozt3QkFFZixJQUFJLEtBQUcsQ0FBQyxRQUFRLEVBQUU7NEJBQ2hCLE1BQU0sSUFBSSxxQkFBUyxDQUFDLEtBQUcsQ0FBQyxRQUFRLENBQUMsTUFBTSxFQUFFLEtBQUcsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUM7eUJBQzdEO3dCQUVELE1BQU0sS0FBRyxDQUFDOzs7OztLQUViO0lBQ0ssNkNBQWtCLEdBQXhCLFVBQ0UsT0FBeUIsRUFDekIsUUFBcUI7Ozs7OzRCQUVDLHFCQUFNLElBQUksQ0FBQyxjQUFjLENBQUMsT0FBTyxDQUFDLEVBQUE7O3dCQUFsRCxhQUFhLEdBQUcsU0FBa0M7d0JBQ2xELGlCQUFpQixHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsWUFBWSxDQUNuRCxRQUFRLEVBQ1IsYUFBYSxDQUNkLENBQUM7d0JBQ0Ysc0JBQU8saUJBQWlCLEVBQUM7Ozs7S0FDMUI7SUFDSCx1QkFBQztBQUFELENBQUMsQUE3Q0QsSUE2Q0M7QUE3Q1ksNENBQWdCIn0=